import React, { useState, useEffect } from 'react';
import ViewReceivedGiftPage from './components/viewReceivedGiftPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getReceivedGiftsList } from './redux/slice';

function ViewReceivedGift() {
  TabTitle('Gift Register - View Gift Request Status');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    receivedGiftsList,
    pagination,
    receivedGiftsLoading,
    CountsReceivedGiftsList
  } = useSelector((state) => state.receivedGifts);
  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [isSwitch, setIsSwitch] = useState(true);

  //console.log('searchRequest', searchRequest);
  //console.log(triggerFilter);
  console.log('receivedGiftsList', receivedGiftsList);

  useEffect(() => {
    handleGetPastGiftsList();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetPastGiftsList();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest, isSwitch]); //page,

  const handleGetPastGiftsList = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest,
      delegation_type: isSwitch === true ? 'self' : 'delegated'
    };
    dispatch(getReceivedGiftsList(payload));
  };
  const onChange = () => {
    setTriggerFilter(true);
    setIsSwitch(!isSwitch);
  };
  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  }; */

  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <ViewReceivedGiftPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          pastGiftsList={receivedGiftsList}
          pagination={pagination}
          pastGiftsListLoading={receivedGiftsLoading}
          CountsReceivedGiftsList={CountsReceivedGiftsList}
          setSearchRequest={setSearchRequest}
          onChange={onChange}
          handleGetPastGiftsList={handleGetPastGiftsList}
        />
      </div>
    </CustomLayout>
  );
}
export default ViewReceivedGift;
